import { ActionDelete, SelectInput } from '@demandlocal/components'
import classNames from 'classnames'
import React, { useEffect, useMemo } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { audienceBuilderConfig, evaluateVisibility } from './config'
import { getOperators } from './utils'
import ValueSelector from './ValueSelector'
import { useDealership } from '../../store/zustand/dealershipStore'

const Rule = ({
  groupIndex,
  ruleIndex,
  handleRuleRemove,
}: {
  groupIndex: number
  ruleIndex: number
  handleRuleRemove: (index: number) => void
}): React.ReactNode => {
  const { setValue } = useFormContext()
  const ruleBaseName = `groups.${groupIndex}.rules.${ruleIndex}`
  const ruleFieldValue = useWatch({ name: `${ruleBaseName}.field` })
  const ruleOperatorValue = useWatch({ name: `${ruleBaseName}.operator` })

  useEffect(() => {
    if (ruleFieldValue?.valueType === 'radio')
      setValue(`${ruleBaseName}.operator`, ruleFieldValue.operators[0])
  }, [ruleBaseName, ruleFieldValue?.operators, ruleFieldValue?.valueType, setValue])

  const hasOperatorSelector = useMemo(
    () => !['radio'].includes(ruleFieldValue?.valueType),
    [ruleFieldValue?.valueType],
  )

  const audienceType = useWatch({ name: 'audience_type' })

  const dealership = useDealership()
  const context = {
    audienceType: audienceType,
    dealership_name: dealership?.dealership,
  }
  const filters = audienceBuilderConfig
    .map((config) => {
      return {
        ...config,
        options: config.options.filter((option) =>
          evaluateVisibility(option.isVisible, context),
        ),
      }
    })
    .filter((config) => config.options.length > 0)
  return (
    <div className="flex items-center w-full">
      <div className="flex items-center justify-between w-full">
        <div className="flex items-end px-4 py-4 gap-8 w-full">
          <div>
            <SelectInput
              menuPlacement="auto"
              placeholder="Select filter..."
              customStyles={{
                maxWidth: '320px',
              }}
              name={`groups.${groupIndex}.rules.${ruleIndex}.field`}
              options={filters}
            />
          </div>
          {ruleFieldValue && (
            <div
              className={classNames('w-full max-w-[25%]', {
                hidden: !hasOperatorSelector,
              })}>
              <SelectInput
                name={`groups.${groupIndex}.rules.${ruleIndex}.operator`}
                options={getOperators(ruleFieldValue.value)}
              />
            </div>
          )}

          {ruleOperatorValue && (
            <div className="w-full max-w-[50%]">
              <ValueSelector
                ruleBaseName={ruleBaseName}
                rule={ruleFieldValue}
                index={ruleIndex}
              />
            </div>
          )}
        </div>

        <div className="mr-4">
          <ActionDelete
            // @ts-ignore
            className="fill-primary-xiketic cursor-pointer scale-[1.4]"
            onClick={() => {
              handleRuleRemove(ruleIndex)
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default Rule
